import { EDTEvent } from '@teetsh/app/src/types/edt';
import { Classroom } from '@teetsh/app/src/types/classroom';
import getDay from 'utils/time/getDay';
import getClassroomsAvailableForThatDay from 'components/EDT/getClassroomsAvailableForThatDay';

function getFilteredClassrooms(event: EDTEvent, classrooms: Classroom[]) {
  return getClassroomsAvailableForThatDay(classrooms, getDay(event.start))
    .map(c => c.id)
    .filter(c => event.classroomIds.includes(c));
}

export function getFilteredEDTEvents(
  events: EDTEvent[],
  classrooms: Classroom[],
  edtStartTime: Date,
  edtEndTime: Date,
) {
  return (
    events
      // We must only keep classrooms open on the day of the event,
      // to avoid basing the calculation of the hourly volume on incorrect elements.
      .map(e => ({ ...e, classroomIds: getFilteredClassrooms(e, classrooms) }))
      .filter(e => {
        if (e.classroomIds.length === 0) {
          return false;
        }

        const endsBeforeStartTime =
          e.end.getHours() < edtStartTime.getHours() ||
          (e.end.getHours() === edtStartTime.getHours() &&
            e.end.getMinutes() <= edtStartTime.getMinutes());

        const startsAfterEndTime =
          e.start.getHours() > edtEndTime.getHours() ||
          (e.start.getHours() === edtEndTime.getHours() &&
            e.start.getMinutes() >= edtEndTime.getMinutes());

        if (endsBeforeStartTime || startsAfterEndTime) {
          return false;
        }

        return true;
      })
  );
}
